import { useState, useRef, useEffect } from 'react';
import img1 from '../../../assets/Menu1.jpg';
import img2 from '../../../assets/Menu2.jpg';
import img3 from '../../../assets/Menu3.jpg';
import img0 from '../../../assets/icon-profile.png';
import logo from '../../../assets/Logo.png';
import { AiOutlineDashboard } from 'react-icons/ai';
import { FiSettings, FiUser, FiImage, FiLogOut } from 'react-icons/fi';
import { MdOutlineCategory } from 'react-icons/md';

const FileUpload = () => {
  // State untuk upload gambar baru
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [uploadStatus, setUploadStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  // State untuk daftar gambar
  const [images, setImages] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  // State untuk edit gambar
  const [editingImage, setEditingImage] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editDescription, setEditDescription] = useState('');

  //state untuk sidebar
  const [activeMenu, setActiveMenu] = useState('Image Upload');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Simulasi fetch data dari API
  useEffect(() => {
    const fetchImages = async () => {
      setIsFetching(true);
      try {
        // Simulasi API call
        await new Promise(resolve => setTimeout(resolve, 800));
        // Data dummy
        const dummyData = [
          { id: 1, image: img1 , title: 'Sample 1', description: 'Contoh image 1', createdAt: '2023-05-15' },
          { id: 2, image: img2 , title: 'Sample 2', description: 'Contoh image 2', createdAt: '2023-05-16' },
          { id: 3, image: img3 , title: 'Sample 3', description: 'Contoh image 3', createdAt: '2023-05-17' },
        ];
        setImages(dummyData);
      } catch (error) {
        console.error('Failed to fetch images:', error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchImages();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setUploadStatus('');

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus('Please select a file first');
      return;
    }

    setIsLoading(true);
    setUploadStatus('Uploading...');

    try {
      // Simulasi upload ke API
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Buat objek gambar baru (dalam real app, ini response dari API)
      const newImage = {
        id: Math.max(...images.map(img => img.id), 0) + 1,
        url: previewUrl,
        title: `Image ${images.length + 1}`,
        description: 'Uploaded image',
        createdAt: new Date().toISOString().split('T')[0]
      };

      setImages([...images, newImage]);
      setUploadStatus('Upload successful!');
      
      // Reset form
      setSelectedFile(null);
      setPreviewUrl('');
      fileInputRef.current.value = '';
    } catch (error) {
      setUploadStatus('Upload failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this image?')) return;

    try {
      // Simulasi API call untuk delete
      await new Promise(resolve => setTimeout(resolve, 800));
      setImages(images.filter(image => image.id !== id));
    } catch (error) {
      console.error('Failed to delete image:', error);
      alert('Failed to delete image');
    }
  };

  const startEditing = (image) => {
    setEditingImage(image);
    setEditTitle(image.title);
    setEditDescription(image.description);
  };

  const cancelEditing = () => {
    setEditingImage(null);
    setEditTitle('');
    setEditDescription('');
  };

  const handleUpdate = async () => {
    if (!editingImage) return;

    try {
      // Simulasi API call untuk update
      await new Promise(resolve => setTimeout(resolve, 800));
      
      setImages(images.map(img => 
        img.id === editingImage.id 
          ? { ...img, title: editTitle, description: editDescription }
          : img
      ));

      setEditingImage(null);
      setEditTitle('');
      setEditDescription('');
    } catch (error) {
      console.error('Failed to update image:', error);
      alert('Failed to update image');
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //Menu items
  const menuItems =[
    {
      name: "Dashboard", icon: <AiOutlineDashboard className="text-lg"/>
    },
    {
      name: "MARKETING", icon: <FiUser className="text-lg"/>,
      subItems: [
        { name: 'Image Upload', icon: <FiImage className="text-lg"/>},
        { name: 'Content', icon: <MdOutlineCategory className='text-lg'/>}
      ]
    },
    {name: 'Settings', icon: <FiSettings className='text-lg'/>}
  ];

  return (
    <div className="flex h-screen bg-aray-100">
      {/* sidebar */}
      
        <div className={`${sidebarOpen ? 'w-64':'w-20'} bg-pink-800 text-white transition-all duration-300 flex flex-col`}>
        <div className="p-4 flex items-center justify-between border-b border-pink-700">
        {sidebarOpen ? (
        <div className="flex items-center space-x-2">
        <div className=" flex items-center justify-center">
        {/* <span className="text-pink-800 font-bold">Dashboard</span> */}
        </div>
        <img src={logo} className="h-12 w-12 object-cover items-center justify-center mx-auto"/>
        <span className="font-bold text-lg">Administrator</span>
        </div>
        ) : ( 
        <div className="w-8 h-8 bg-white rounded flex items-center justify-center mx-auto">
        <span className="text-blue-800 font-bold">S</span>
        </div>
        )}
        <button onClick={() => setSidebarOpen(!sidebarOpen)}
        className="p-1 rounded-full hover:bg-pink-700">
        {sidebarOpen ? '<' : '>'}
        </button>
      </div>

      {/* User Profile */}
      <div className="p-4 border-b border-pink-700">
        {sidebarOpen ? (
          <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-full bg-white flex-center justify-center">
            <img src={img0} alt=""
            className="w-10 h-10 rounded-full flex-center justify-center object-cover"/>
            {/* <span className="text-white">AD</span> */}
            </div>
            <div className='items-center justify-center mx-auto'>
              <p className="font-medium text-white font-semibold">CHANDRA</p>
              {/* <p className="text-xs text-pink-200">Super Admin</p> */}
            </div>
            </div>
        ) : (
          <div className="w-10 h-10 rounded-full bg-pink-600 flex items-center justify-center">
            <span className="text-white">AD</span>
            </div>
        )}
      </div>

        {/* Menu Items */}
        <div className="flex-1 overflow-y-auto py-2">
          {menuItems.map((item, index) => (
            <div key={index}>
              <div
                className={`px-4 py-3 flex items-center space-x-3 cursor-pointer hover:bg-pink-700 ${activeMenu === item.name ? 'bg-pink-700' : ''}`}
                onClick={() => setActiveMenu(item.name)}>
                  <span>{item.icon}</span>
                  </div>

          {/* Sub Items */}
          {item.subItems && sidebarOpen && (
            <div className="ml-4 pl-4 border-l border-pink-700">
              {item.subItems.map((subItem, subIndex) => (
                <div
                key={subIndex}
                className={`px-2 py-2 flex items-center space-x-3 cursor-pointer hover:bg-pink-700 rounded ${activeMenu === subItem.name ? 'bg-pink-700' : ''}`}
                onClick={() => setActiveMenu(subItem.name)}>
              <span>{subItem.icon}</span>
              <span className="text-sm">{subItem.name}</span>
                </div>
                ))}
                </div>
          )}
          </div>
          ))}
          </div>

          {/* Logout */}
          <div className="p-4 border-t border-pink-700">
          <div className="flex items-center space-x-3 cursor-pointer hover:bg-pink-700 p-2 rounded">
            <FiLogOut className="text-lg"/>
            {sidebarOpen && <span>Logout</span>}
            </div>
          </div>
        </div>

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto">
            <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="flex justify-between items-center mb-8">
              <h1 className="text-3xl font-bold text-gray-800">{activeMenu}</h1>
              <span className="bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-0.5 rounded">Administrator Mode</span>
            </div>

                   
{/* 
            )}
          </div>
     </div>
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Image Management</h1>
          <span className="bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-0.5 rounded">Administrator Mode</span>
        </div> */}

            {/* Content based on active menu */}
            {activeMenu === 'Image Upload' ? (
              <>

        {/* Upload Section */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden mb-8">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Upload New Image</h2>
            
            <div 
              className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center mb-4 cursor-pointer hover:border-blue-400 transition-colors"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*"
                className="hidden"
              />
              {previewUrl ? (
                <div className="flex flex-col items-center">
                  <img 
                    src={previewUrl} 
                    alt="Preview" 
                    className="max-h-60 mb-4 rounded-md shadow-sm"
                  />
                  <p className="text-sm text-gray-600">{selectedFile.name}</p>
                </div>
              ) : (
                <>
                  <svg
                    className="mx-auto h-12 w-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                  <p className="mt-2 text-sm text-gray-600">
                    <span className="font-semibold text-blue-600">Click to upload</span> or drag and drop
                  </p>
                  <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
                </>
              )}
            </div>

            <div className="flex justify-between items-center">
              <button
                onClick={handleUpload}
                disabled={!selectedFile || isLoading}
                className={`px-4 py-2 rounded-md text-white font-medium ${
                  !selectedFile || isLoading
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Uploading...
                  </span>
                ) : 'Upload Image'}
              </button>

              {selectedFile && (
                <button
                  onClick={() => {
                    setSelectedFile(null);
                    setPreviewUrl('');
                    fileInputRef.current.value = '';
                    setUploadStatus('');
                  }}
                  className="px-4 py-2 rounded-md text-gray-700 font-medium border border-gray-300 hover:bg-gray-50"
                >
                  Cancel
                </button>
              )}
            </div>

            {uploadStatus && (
              <p className={`mt-3 text-sm ${
                uploadStatus.includes('success') ? 'text-green-600' : 
                uploadStatus.includes('failed') ? 'text-red-600' : 'text-gray-600'
              }`}>
                {uploadStatus}
              </p>
            )}
          </div>
        </div>

        {/* Image List Section */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Image Gallery</h2>
            
            {isFetching ? (
              <div className="flex justify-center items-center py-12">
                <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            ) : images.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No images found. Upload your first image.
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {images.map(image => (
                  <div key={image.id} className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                    {editingImage?.id === image.id ? (
                      <div className="p-4">
                        <div className="mb-4">
                          <img 
                            src={image.url} 
                            alt={image.title} 
                            className="w-full h-48 object-cover rounded"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                          <input
                            type="text"
                            value={editTitle}
                            onChange={(e) => setEditTitle(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                          <textarea
                            value={editDescription}
                            onChange={(e) => setEditDescription(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md"
                            rows="2"
                          />
                        </div>
                        <div className="flex justify-end space-x-2">
                          <button
                            onClick={cancelEditing}
                            className="px-3 py-1 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleUpdate}
                            className="px-3 py-1 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <img 
                          src={image.url} 
                          alt={image.title} 
                          className="w-full h-48 object-cover"
                        />
                        <div className="p-4">
                          <h3 className="font-medium text-lg mb-1">{image.title}</h3>
                          <p className="text-gray-600 text-sm mb-2">{image.description}</p>
                          <p className="text-gray-400 text-xs mb-3">Uploaded: {image.createdAt}</p>
                          <div className="flex justify-end space-x-2">
                            <button
                              onClick={() => startEditing(image)}
                              className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDelete(image.id)}
                              className="px-3 py-1 text-sm text-red-600 hover:text-red-800"
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </>
            ) : (
              <div className="bg-white rounded-xl shadow-md overflow-hidden p-6 text-center">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">{activeMenu} Content</h2>
                <p className="text-gray-600">This is {activeMenu.toLowerCase()} page content.</p>
                </div>
            )}
      </div>
    </div>
    </div>
    </div>
  );
};

export default FileUpload;